<template>
  <div class="medium-12 columns">
    <div class="canned__list-search">
      <fluent-icon icon="search" class="search-icon" size="16" />
      <input
        ref="search"
        v-model="query"
        :placeholder="$t('CANNED_MGMT.SEARCH_PLACEHOLDER')"
        class="canned__search-input"
      />
    </div>
    <div class="canned__list-container">
      <div
        v-for="(response, i) in filteredCannedResponses"
        :key="response.short_code"
      >
        <button class="canned__list-item" @click="$emit('onSelect', response)">
          <div>
            <p class="label-title">{{ response.short_code }}</p>
            <p class="label-body">{{ response.content }}</p>
          </div>
        </button>
        <hr v-if="i != filteredCannedResponses.length - 1" :key="`hr-${i}`" />
      </div>
      <div v-if="!filteredCannedResponses.length">
        <p>
          {{ $t('CANNED_MGMT.NO_RESPONSES_FOUND') }}
          <strong>{{ query }}</strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FluentIcon from 'shared/components/FluentIcon/Index.vue';

export default {
  components: { FluentIcon },
  props: {
    inboxId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      query: '',
    };
  },
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
    }),
    filteredCannedResponses() {
      return this.cannedMessages.filter(
        response =>
          response.short_code
            .toLowerCase()
            .includes(this.query.toLowerCase()) ||
          response.content.toLowerCase().includes(this.query.toLowerCase())
      );
    },
  },
  watch: {
    query() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses();
  },
  methods: {
    fetchCannedResponses() {
      this.$store.dispatch('getCannedResponse', {
        searchKey: this.searchKey,
        inboxId: this.inboxId,
        fetchAll: false
      });
    },
  },
};
</script>

<style scoped lang="scss">
.canned__list-search {
  align-items: center;
  background-color: var(--s-25);
  border-radius: var(--border-radius-medium);
  border: 1px solid var(--s-100);
  display: flex;
  margin-bottom: var(--space-one);
  padding: 0 var(--space-one);
}

.search-icon {
  color: var(--s-400);
}

.canned__search-input {
  background-color: transparent;
  border: none;
  font-size: var(--font-size-mini);
  height: 3rem;
  line-height: 3rem;
  text-align: left;
  width: 100%;
  padding: 0 1rem;
}

.canned__list-container {
  background-color: var(--s-25);
  border-radius: var(--border-radius-medium);
  max-height: 30rem;
  overflow-y: auto;
  padding: var(--space-one);
}

.canned__list-item {
  border-radius: var(--border-radius-medium);
  cursor: pointer;
  display: block;
  padding: var(--space-one);
  text-align: left;
  width: 100%;

  &:hover {
    background-color: var(--w-50);
  }
}

.label-title {
  font-size: var(--font-size-small);
  font-weight: bold;
}

.label-body {
  font-family: monospace;
}

hr {
  border-bottom: 1px solid var(--s-100);
  margin: var(--space-one) auto;
  max-width: 95%;
}
</style>